import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import PageTitle from "./PageTitle";
import Spacer from "./Spacer";
import { getParticipantIdFromSearchParams } from '../utils/urlParams';
import './DemographicsPage.styles.css';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();

const QUESTION_OTHER_OPINION = `Do you have any other opinion to share?`;

const PostGameOtherOpinionPage: React.FC = () => {
  const [additionalComments, setAdditionalComments] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const participantId = getParticipantIdFromSearchParams(window.location.search);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!participantId) {
      setError("Participant ID missing from URL. Please use your study link (e.g. ?participantId=... or ?prolificID=...).");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE_URL}/postGameQuestions/additionalComments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'prolific-id': participantId,
        },
        body: JSON.stringify({
          additionalComments: additionalComments.trim() || undefined,
        }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        const errMsg = typeof data.error === 'string' ? data.error : 'Failed to submit your response.';
        setError(errMsg);
        setSubmitting(false);
        return;
      }

      setSubmitted(true);
      setTimeout(() => {
        navigate('/post-game-risk?' + queryParams.toString());
      }, 1000);
    } catch {
      setError('Network error. Please try again.');
      setSubmitting(false);
    }
  };

  const textareaStyle = {
    width: '100%' as const,
    minHeight: '120px' as const,
    padding: '12px' as const,
    border: '1.2px solid #c3d6ee' as const,
    borderRadius: '8px' as const,
    fontSize: '1em' as const,
    background: '#f7fbff' as const,
    color: '#222' as const,
    outline: 'none' as const,
    transition: 'border 0.2s, box-shadow 0.2s' as const,
    boxShadow: '0 1px 4px rgba(25, 118, 210, 0.02)' as const,
    fontFamily: 'inherit' as const,
    resize: 'vertical' as const,
  };

  if (submitted) {
    return (
      <div className="demographics-bg">
        <div className="demographics-card fade-in postgame-reflection-card">
          <div className="demographics-thankyou">
            Thank you! Continuing...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="demographics-bg">
      <div className="demographics-card fade-in postgame-reflection-card">
        <PageTitle title="Final Reflection" />
        <Spacer />

        <form onSubmit={handleSubmit} className="demographics-form">
          {error && <div className="demographics-error">{error}</div>}

          <div className="demographics-field">
            <label>
              <span className="demographics-label" style={{ marginBottom: 8, display: 'block' }}>
                {QUESTION_OTHER_OPINION}
              </span>
              <div style={{ marginTop: 6 }}>
                <textarea
                  value={additionalComments}
                  onChange={(e) => setAdditionalComments(e.target.value)}
                  placeholder="Optional — share anything else you'd like..."
                  style={textareaStyle}
                />
              </div>
            </label>
          </div>

          <button
            type="submit"
            className="demographics-submit"
            disabled={submitting}
          >
            {submitting ? 'Submitting...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PostGameOtherOpinionPage;
